<template>
  <v-row class="box-container ma-0 pa-0" justify="start">
    <div class="row-header ma-0 pa-0">
      <v-row class="ma-2" align="center">
        <v-select v-model="sortType" @change="sort" class="ma-2 mt-3 pa-0" :style="isOnMobile ? 'max-width: 160px;' : 'max-width: 250px;'" hide-details :items="isOnMobile ? sortListMobile : sortList" :label="s_Sort" dense />
        <t-filter-button :datatype="datatype" class="ma-0 pa-0" @click.native="isFilterMenuVisible = !isFilterMenuVisible" />
      </v-row>
      <v-row class="ma-1" v-if="isFilterMenuVisible">
        <v-card class="ma-1 pa-2">
          <t-filters v-if="isFilterMenuVisible" :datatype="datatype" />
        </v-card>
      </v-row>
    </div>
    <div class="row-content ma-0 pa-0" ref="refDeviceDataContent" v-resize:debounce="recalcWidthHeight" align="center">
      <template v-if="TR.Locale == Translation.bg.Locale">
        <v-virtual-scroll
          class="ma-0 pa-0"
          :style="fdEditIndex == -1 ? 'overflow-y: auto;' : 'overflow-y: hidden;'"
          v-scroll.self="virtualScrollerScrolled"
          :height="virtualScrollerHeight"
          ref="refVirtualScroll"
          :bench="1"
          :item-height="editDeviceItemHeight"
          :items="getData"
          :width="virtualScrollerWidth"
        >
          <template v-slot="{ item }">
            <DeviceInformationSingle :device="item" :class="'ma-2 my-1 pa-2'" />
          </template>
        </v-virtual-scroll>
      </template>
      <template v-else>
        <v-virtual-scroll
          class="ma-0 pa-0"
          :style="fdEditIndex == -1 ? 'overflow-y: auto;' : 'overflow-y: hidden;'"
          v-scroll.self="virtualScrollerScrolled"
          :height="virtualScrollerHeight"
          ref="refVirtualScroll"
          :bench="1"
          :item-height="editDeviceItemHeight"
          :items="getData"
          :width="virtualScrollerWidth"
        >
          <template v-slot="{ item }">
            <DeviceInformationSingleGlobal :device="item" :class="'ma-2 my-1 pa-2'" />
          </template>
        </v-virtual-scroll>
      </template>
    </div>
  </v-row>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import router from "../../router";
import DataManager, { ErrorMessage } from "../../js/DataManager";
import bus, { TR } from "../../main";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import L, { latLng, latLngBounds } from "leaflet";
import { EsriProvider } from "leaflet-geosearch";
import TextButton from "../Controls/TextButton";
import DeviceInformationSingle from "./DeviceInformationSingle";
import DeviceInformationSingleGlobal from "./DeviceInformationSingleGlobal";
import Translation from "../../js/Translation";
const provider = new EsriProvider();

export default {
  props: ["source", "userprop"],
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    TextButton,
    DeviceInformationSingle,
    DeviceInformationSingleGlobal,
  },
  data() {
    return {
      searchText: "",
      isFilterMenuVisible: false,
      headerButtonsHeight: 70,
      virtualScrollerHeight: 500,
      virtualScrollerWidth: "100vw",
      virtualScrollerOffset: 0,
      intervalRecalcSize: null,
      filtersCount: 0,
      showMap: false,
      tempName: null,
      fdEditIndex: -1,
      user: this.userprop,
      expandedPanel: -1,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      currentZoom: 7.2,
      currentCenter: latLng(42.7902107, 25.4090009),
      currentMinZoom: 6.4,
      currentMaxBounds: latLngBounds([44.405133, 22.093418], [41.361333, 28.602028]),
      datatype: null,
      dataitems: [],
      dataitemslatlng: {},
      dataitemsicons: {},
      dataheaders: [],
      message: null,
      technicians: [],
      title: "",
      buttons: [
        {
          text: TR.Subscription,
          icon: "mdi-semantic-web",
          click: this.showSubscribe,
        },
      ],
      s_Sort: TR.Sort,
      sortType: TR.Device_Name,
      sortList: [
        TR.DeviceList_NameAsc,
        TR.DeviceList_NameDesc,
        TR.DeviceList_SnAsc,
        TR.DeviceList_SnDesc,
        TR.DeviceInformation_DailyTurnoverAsc,
        TR.DeviceInformation_DailyTurnoverDesc,
        TR.DeviceInformation_WeeklyTurnoverAsc,
        TR.DeviceInformation_WeeklyTurnoverDesc,
      ],
      sortListMobile: [
        TR.DeviceList_NameAsc_mobile,
        TR.DeviceList_NameDesc_mobile,
        TR.DeviceList_SnAsc_mobile,
        TR.DeviceList_SnDesc_mobile,
        TR.DeviceInformation_DailyTurnoverAsc_mobile,
        TR.DeviceInformation_DailyTurnoverDesc_mobile,
        TR.DeviceInformation_WeeklyTurnoverAsc_mobile,
        TR.DeviceInformation_WeeklyTurnoverDesc_mobile,
      ],
      onfocus: false,
      TR: TR,
      Translation: Translation,
    };
  },
  computed: {
    getData() {
      if (this.message) {
        router.push({ path: "/login", params: { errors: this.message } });
        this.dialogLoader.showError(this.message);
        return [];
      } else {
        return this.dataitems;
      }
    },
    getLatLng() {
      return this.dataitemslatlng;
    },
    getIcons() {
      return this.dataitemsicons;
    },
  },
  methods: {
    showModalMap(devaddress, maplatlng) {
      this.dialog.show("google-map", null, {
        //this.$modal.show("modal-map", {
        address: devaddress,
        latlng: maplatlng,
      });
    },
    recalcWidthHeight() {
      if (this.intervalRecalcSize) clearTimeout(this.intervalRecalcSize);
      this.intervalRecalcSize = setTimeout(() => {
        if (this.$refs.refDeviceDataContent) {
          this.virtualScrollerHeight = this.$refs.refDeviceDataContent.clientHeight;
          this.virtualScrollerWidth = this.$refs.refDeviceDataContent.clientWidth;
        }
      }, 333);
    },
    expandSpecific(serialNum) {
      setTimeout(() => {
        //, collapseIfExpanded) {
        let devIndex = this.getData.findIndex((dev) => dev.sn.toLowerCase().contains(serialNum.toLowerCase()));
        if (devIndex == -1) {
          devIndex = this.getData.findIndex((dev) => dev.Name.toLowerCase().contains(serialNum.toLowerCase()));
        }
        if (devIndex != -1) {
          //if (collapseIfExpanded) this.isExpanded = !this.isExpanded;
          //else this.isExpanded = true;
          this.expandedPanel = devIndex;
          this.setFocusOnDevice(devIndex);
        } else {
          this.highlighter.stop();
        }
      }, 500);
    },
    virtualScrollerScrolled() {
      if (this.expandedPanel >= 0) {
        //this.highlighter.highlight(this.$refs["refDeviceStatus" + this.getData[this.expandedPanel].sn].$el);
        this.expandedPanel = -1;
      }
    },
    setFocusOnDevice(deviceIndex) {
      if (this.$refs.refVirtualScroll) {
        this.$refs.refVirtualScroll.$el.scrollTop = deviceIndex * this.editDeviceItemHeight;
        //this.$refs.refVirtualScroll.scrollToItem(deviceIndex + 1);
        // this.$refs.refVirtualScroll.$el.scrollTo({
        //   top: deviceIndex * this.editDeviceItemHeight,
        //   left: 0,
        //   behavior: "smooth",
        // });
        //this.$refs.refVirtualScroll.$el.scrollTo(0, deviceIndex * this.editDeviceItemHeight);
      }
    },
    searchTextChanged() {
      if (this.searchText.length > 30) {
        this.searchText = this.searchText.substring(0, 29);
      }
      this.$nextTick(() => {
        this.expandSpecific(this.searchText);
      });
    },
    // getLastMonday(d) {
    //   d = new Date(d);
    //   var day = d.getDay(),
    //     diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    //   return new Date(d.setDate(diff));
    // },
    refreshData() {
      this.dataitems = [];
      this.$nextTick(() => {
        //fixes edit name bug
        this.dataitems = DataManager.getData(this.datatype);
      });
    },
    /**
     * @param {DataManager.DataType} datatype
     * @param {ErrorMessage} error
     */
    setTitleAndData(meta, error) {
      this.datatype = meta.datatype;
      this.title = meta.title;
      this.technicians = DataManager.getData(DataManager.DataType.user, true).settings2.technicians;
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.dataheaders = DataManager.getHeaders(this.datatype);
        this.dataheaders.forEach((f) => {
          if (!f.hidden) this.$set(f, "hidden", false);
        });
        this.refreshData();
      } else {
        this.message = error.Message;
      }
    },
    setFocus(on) {
      this.onfocus = on;
      this.fdEditIndex = -1;
      if (on) {
        this.$refs.refVirtualScroll.$el.scrollTop = this.virtualScrollerOffset;
      } else {
        this.virtualScrollerOffset = this.$refs.refVirtualScroll.$el.scrollTop;
      }
    },
    loadMap(i) {
      var vm = this;
      this.showMap = false;
      if (vm.dataitemsicons[i.sn] == null) {
        vm.dataitemsicons[i.sn] = L.icon({
          iconUrl: i.Image,
          shadowUrl: i.Image,
          iconSize: [40, 40],
          shadowSize: [0, 0],
          iconAnchor: [20, 20],
          shadowAnchor: [0, 0],
          popupAnchor: [0, 0],
        });
        provider.search({ query: i.Address }).then((result) => {
          if (result.length > 0) {
            vm.dataitemslatlng[i.sn] = latLng(result[0].y, result[0].x);
            this.$nextTick(() => {
              try {
                if (this.$refs["refMap" + i.sn] && this.$refs["refMap" + i.sn].mapObject) {
                  this.$refs["refMap" + i.sn].mapObject.setView(vm.dataitemslatlng[i.sn], 13);
                }
              } catch {
                /** ignored */
              }
            });
          }
          vm.showMap = true;
        });
      } else {
        vm.showMap = true;
      }
    },
    sort() {
      var sl = this.isOnMobile ? this.sortListMobile : this.sortList;
      let type = this.sortType;
      this.dataitems.sort(function (a, b) {
        if (type == sl[0]) return a.Name < b.Name ? -1 : a.Name > b.Name ? 1 : 0;
        else if (type == sl[1]) return a.Name > b.Name ? -1 : a.Name < b.Name ? 1 : 0;
        else if (type == sl[2]) return a.sn < b.sn ? -1 : a.sn > b.sn ? 1 : 0;
        else if (type == sl[3]) return a.sn > b.sn ? -1 : a.sn < b.sn ? 1 : 0;
        else if (type == sl[4]) return a.DailyTurnover - b.DailyTurnover;
        else if (type == sl[5]) return b.DailyTurnover - a.DailyTurnover;
        else if (type == sl[6]) return a.WeeklyTurnover - b.WeeklyTurnover;
        else if (type == sl[7]) return b.WeeklyTurnover - a.WeeklyTurnover;
      });
    },
  },
  // watch: {
  //   expandedPanel: function(oldVal) {
  //     if (oldVal != undefined) {
  //       var dev = this.getData[oldVal];
  //       this.loadMap(dev);
  //     }
  //   }
  // },
  created() {
    // bus.$on(bus.EVENT_DataManager_DATA_CHANGED, (datatype) => {
    //   if (datatype == DataManager.DataType.sales) {
    //     this.calcDailyWeekly();
    //   }
    // });
    bus.$on(bus.EVENT_DataManager_FILTERS_CHANGED, (datatype) => {
      if (datatype == this.datatype && this.onfocus) {
        this.refreshData();
      }
    });

    bus.$on(bus.EVENT_Device_subscribtion_changed, () => {
      this.refreshData();
    });
    bus.$on(bus.EVENT_DeviceDiv_ExpandInfoBySerialNumber, (serialNum) => {
      this.$nextTick(() => this.expandSpecific(serialNum));
    });
    bus.$on(bus.EVENT_DataManager_DATA_CHANGED, (datatype) => {
      if (datatype == DataManager.DataType.devices && this.onfocus) {
        this.refreshData();
      }
    });
    bus.$on(bus.EVENT_Device_started_to_edit, (index) => {
      this.fdEditIndex = index;
    });
  },
  mounted() {
    this.recalcWidthHeight();
    window.addEventListener("resize", this.recalcWidthHeight);
  },
  updated() {
    this.recalcWidthHeight();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.recalcWidthHeight);
  },
};
</script>
<style lang="css">
/* body {
  color: rgba(219, 219, 219, 0.849);
} */
</style>